import { BasicInput, BasicInputProps } from '@/view/components/BasicInput'
import { ReactNode } from 'react'

interface InputProps extends BasicInputProps {
  label: string
  name: string
  error?: string
  icon?: ReactNode
  maxLength?: number
}

export const Input = ({ label, name, error, icon, maxLength, onInput, ...props }: InputProps) => {
  return (
    <div>
      <div className="leading-none">
        <BasicInput
          label={
            <div className='flex flex-row items-center ml-2 mb-1 leading-none'>
              {/* <div className="flex items-center  leading-none"> */}
              {icon}
              {/* </div> */}
              <span className="text-gray-700 font-semibold text-left flex flex-col items-right dark:text-gray-200">{label}</span>
            </div>
          }
          maxLength={maxLength}
          style={{
            border: '1px solid darkgray',
            outline: 'none',
            boxShadow: 'none',
            borderRadius: '12px',
          }}
          onInput={onInput}
          labelClass="leading-none text-left"
          name={name}
          className=" mt-0 h-10 w-full text-sm font-medium placeholder:text-black04 focus:border-transparent focus:outline-none focus:ring-0 sm:text-base leading-none"
          {...props}
        />
        {error && (
          <div className="min-h-5 mt-1 text-left text-xs sm:text-sm text-error">{error}</div>
        )}
      </div>
    </div>
  )
}
